import Loading from "@/components/Loading/Loading";
import {AuthProvider} from '@/context/AuthProvider';
import "bootstrap/scss/bootstrap.scss";

// ========= Plugins CSS START =========
import "../public/css/plugins/feature.css";
import "../public/css/plugins/animation.css";
import "../node_modules/sal.js/dist/sal.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-tooltip/dist/react-tooltip.css";
// ========= Plugins CSS END =========
import "../public/scss/style.scss";
import {UserProvider} from '@/context/UserContext';
import {ClerkProvider} from '@clerk/nextjs';
import {AppCacheProvider} from '@mui/material-nextjs/v13-pagesRouter';
import {Analytics} from '@vercel/analytics/react';
import {SpeedInsights} from "@vercel/speed-insights/next";
import {Router} from "next/router";
import React, {useEffect, useState} from "react";
import Head from "next/head";

export default function App({Component, pageProps}) {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        require("bootstrap/dist/js/bootstrap.bundle.min.js");

        const handleStart = (url) => url !== Router.asPath && setLoading(true);
        const handleComplete = () => setLoading(false);

        Router.events.on("routeChangeStart", handleStart);
        Router.events.on("routeChangeComplete", handleComplete);
        Router.events.on("routeChangeError", handleComplete);

        return () => {
            Router.events.off("routeChangeStart", handleStart);
            Router.events.off("routeChangeComplete", handleComplete);
            Router.events.off("routeChangeError", handleComplete);
        };
    }, []);

    return (
        <ClerkProvider {...pageProps}>
            <AppCacheProvider>
                <AuthProvider>
                    <UserProvider>
                        <Head>
                            {/*<title>Resume Lint - Optimize Your Resume for Job Applications</title>*/}
                            <meta name="viewport" content="width=device-width, initial-scale=1"/>
                            <link rel="icon" href="/favicon.ico"/>
                            <link rel="canonical" href={typeof window !== "undefined" ? window.location.href : ""}/>
                        </Head>
                        <SpeedInsights/>
                        {loading ? <Loading/> : <Component {...pageProps} />}
                        <Analytics/>
                    </UserProvider>
                </AuthProvider>
            </AppCacheProvider>
        </ClerkProvider>
    );
}